import React, { useState } from 'react';
import { CollapsibleTableHeader } from './CollapsibleTableHeader';
import './CollapsibleTable.scss';
import {
    CollapsibleTableRow,
    CollapsibleTableRowInputs,
} from './CollapsibleTableRow';

export interface CollapsibleTableInputs {
    expandedByDefault?: boolean;
    header: string;
    headerRight: string;
    quantityLabel: string;
    id: string;
    tableType: string;
    subHeader?: string;
    subHeaderRight?: string;
    rows: CollapsibleTableRowInputs[];
}

export const CollapsibleTable = ({
    inputs,
}: {
    inputs: CollapsibleTableInputs;
}) => {
    const [expanded, setExpanded] = useState(inputs.expandedByDefault);
    const [items, setItems] = useState(inputs.rows);
    function handleExpansionClick() {
        for (const i of items) {
            if (this !== i) i.rowExpanded = false;
        }
        this.rowExpanded = !this.rowExpanded;
        setItems([...items]);
    }

    return (
        <section
            className={`paragraph__collapsible_table ${
                inputs.tableType && inputs.tableType
            } kite-container  ${
                inputs.tableType === `secondary` ? `` : !expanded && `collapsed`
            }`}
        >
            <CollapsibleTableHeader
                header={inputs.header}
                headerRight={inputs.headerRight}
                quantityLabel={inputs.quantityLabel}
                tableType={inputs.tableType}
                subHeader={inputs.subHeader}
                subHeaderRight={inputs.subHeaderRight}
                expanded={expanded}
                setExpanded={setExpanded}
            />
            <ul id="" aria-hidden={!expanded}>
                {inputs.rows?.map((row, index) => (
                    <CollapsibleTableRow
                        key={`${row.id}_${row.mainText}`}
                        id={row.id}
                        mainText={row.mainText}
                        secondaryText={row.secondaryText}
                        url={row.url}
                        rowExpanded={row.rowExpanded}
                        nestedRows={row.nestedRows}
                        handleExpansionClick={handleExpansionClick.bind(row)}
                    />
                ))}
            </ul>
        </section>
    );
};
